import { render, staticRenderFns } from "./label-form.vue?vue&type=template&id=a2389fba&"
import script from "./label-form.vue?vue&type=script&lang=js&"
export * from "./label-form.vue?vue&type=script&lang=js&"
import style0 from "./label-form.vue?vue&type=style&index=0&module=true&lang=less&"
import style1 from "./label-form.vue?vue&type=style&index=1&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports